import { EmailClass, SendType } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const headList = [
  {
    headTitle: "メール種別",
  },
  {
    headTitle: "タイトル",
  },
  {
    headTitle: "送信先",
  },
  {
    headTitle: "作成日時",
  },
  {
    headTitle: "送信日時",
  },
  {
    headTitle: "送信成否",
  },
];

const listData: any = [
  {
    keyword: "emailClass",
    type: "selectFrom",
    label: "メール種別",
    selectPropsList: TkGetCodeList(EmailClass),
  },
  {
    keyword: "sendFlg",
    type: "selectFrom",
    label: "送信成否",
    selectPropsList: TkGetCodeList(SendType),
  },
  {
    keyword: "contractorNo",
    type: "label",
    label: "共済契約者番号",
    inputProps: {
      maxLength: 6,
    },
  },
  {
    keyword: "corpName",
    type: "label",
    label: "共済契約者名",
    inputProps: {
      maxLength: 85,
    },
  },
  {
    keyword: "sendName",
    type: "label",
    label: "送信先名",
    inputProps: {
      maxLength: 85,
    },
  },
];
const schema = {
  contractorNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },
    minLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },
  },
  corpName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  sendName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { headList, listData, schema };
